









import Vue from 'vue';
import TableProvider from '@/api/TableProvider';
import { execLoad, ILoadable, makeLoadable } from '@/util/Loadable';
import { ITableRow } from '@vincentzhang96/dv-dnt-table-interfaces';
import { Segment } from '@/models/skills/blows/types';
import { seg } from '@/models/skills/blows/segments';
import { enhanceToCell } from '@/models/skills/blows/misc';

interface IEnhanceSkillBlowRow extends ITableRow {
    _EnhanceID: number;
    _FromSkillID: number;
    _ToSkillID: number;
    _OverrideColor: string;
    _UseCount: number;
}

type IData = ILoadable<IEnhanceSkillBlowRow[]>;

export default Vue.extend({
    name: 'EnhanceTableRows',
    beforeCreate() {
        // break the BlowSegments <-> EnhanceTableRows cycle
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        (this.$options.components as any).BlowSegments = require('./BlowSegments.vue').default;
    },
    props: {
        setId: {
            type: Number as () => number,
            required: true,
        },
        defaultColor: {
            type: String as () => string | null,
            default: null,
        },
        spans: {
            type: Array as () => Array<[number, number]> | null,
            default: null,
        },
    },
    data(): IData {
        return {
            ...makeLoadable(),
        };
    },
    computed: {
        tableSegments(): Segment[] | null {
            if (!this.value || !this.value.length) {
                return null;
            }
            const rows: Segment[][][] = this.value.map((row) => [
                [seg.skill(row._FromSkillID)],
                enhanceToCell(
                    row._ToSkillID,
                    (row._OverrideColor || '').trim(),
                    row._UseCount,
                    this.defaultColor,
                ),
            ]);
            return [seg.table(rows)];
        },
    },
    watch: {
        setId() {
            this.load();
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            await execLoad(this, async () => {
                return await TableProvider.getTableRowsMatching<IEnhanceSkillBlowRow>(
                    'pd_enhanceskillblowtable', '_EnhanceID', '==', this.setId,
                );
            });
        },
    },
});
